import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";
import { IStorePlaceGetDTO, IStorePlaceViewDTO } from "../../coreapi-dto/dirs/storePlace";


interface IStorePlaceCreate extends IStorePlaceGetDTO {
}
interface IStorePlaceUpdate extends IStorePlaceGetDTO{
}

class StorePlaceRequest extends BaseDirRequest<IStorePlaceViewDTO, IStorePlaceGetDTO> {

    constructor(baseUrl:string, token:string, eventHandler: IRequestEventHandler){
        super(baseUrl, "StorePlace", token, eventHandler)
    }

    create(body: IStorePlaceCreate, callback: (e:CoreApiResponse<string>)=>void){
        super.create(body,callback)
    }
    
    update(idGlobal:string, body: IStorePlaceUpdate, callback: (e:CoreApiResponse<null>)=>void){
        super.update(idGlobal,body,callback)
    }
}

export default StorePlaceRequest